/*
 * This is the Dexie database used for storing data locally in the browser's IndexedDB.
 */
import Dexie from 'dexie'

////////////////////////
//
/////////////////////////////////////////////
//
/////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
//
//////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
 
//////////

var db = new Dexie("xhale");

// Define the database schemas.

// NOTE: Do not delete old versions of the schema until we are sure all users
// will have upgraded.

db.version(1).stores({notes: 'id', athletes: 'id'});
db.version(2).stores({notes: 'id', athletes: 'id', groups: 'id'});
db.version(3).stores({table_metadata: 'table_name', athletes: 'id', groups: 'id', notes: 'id'});
db.version(4).stores({table_metadata: 'table_name', athletes: 'id', groups: 'id', template_training_sessions: 'id, athlete_id, group_id, template_sharing, [athlete_id+template_sharing], [group_id+template_sharing]', template_folders: 'id, athlete_id, group_id, template_sharing, [athlete_id+template_sharing], [group_id+template_sharing]', notes: 'id'});

export let database = db

